import React from "react";
import Calculator from "./components/Calculator";

function App() {
  return (
    <div className="bg-gradient-to-b from-teal-50 to-white min-h-screen flex flex-col">
      <header className="bg-teal-100 text-teal-900 py-6 text-center shadow-md">
        <h1 className="text-3xl font-semibold">Bunk Balance</h1>
        <h2 className="text-1xl font-bold">Attendance Calculator</h2>
        <p className="mt-2 text-lg">
          Calculate the number of days you can bunk or need to attend!
        </p>
      </header>
      
      <main className="flex-grow flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white p-6 rounded-lg shadow-lg border border-teal-200">
          <Calculator />
        </div>
      </main>
      
      <footer className="text-center text-sm text-teal-600 py-4 bg-teal-50 shadow-inner">
        Built by Musham Varun. Inspired from{" "}
        <a
          href="https://www.attendance75.in/"
          className="text-teal-500 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          75attendance
        </a>
        <br/>
        <p><strong className="text-red-500 font-bold">Disclaimer:</strong> This website does not promote bunking of Classes. Bunk Balance is just named <strong>Sarcastically</strong></p>
      </footer>
    </div>
  );
}

export default App;
